require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import Notifications from "notiwind";
import PrimeVue from "primevue/config";
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';

import MultiSelect from "primevue/multiselect";

import { createI18n } from "vue-i18n";
import { de } from "@/Shared/Locale/de";

export const i18n = createI18n({
    locale: "de",
    fallbackLocale: "de",
    messages: {
        de: de,
    },
});

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(PrimeVue)
            .use(Notifications)
            .component("MultiSelect", MultiSelect)
            .component("OverlayPanel", OverlayPanel)
            .component("Dialg", Dialog)
            .component("Calendar", Calendar)
            .mixin({ methods: { route } })
            .mount(el);
    },
    progress: { color: '#4B5563' },
});
